import { Directive, Input, forwardRef, OnChanges } from "@angular/core";
import { FormControl, Validator, AbstractControl, NG_VALIDATORS, ValidatorFn } from "@angular/forms";
import { IDropDownView, IDropDownItemView } from "../interfaces/idropdowns";

export interface IValidationResult {
 [key:string]: boolean;
}

/**
 * Checks to see if the drop down item being edited/created has already been used based on the text for the control.
 * Returns null if valid, otherwise returns the validator and control value
 * @param dropDown The drop down the items are being added to and to check items against
 * @param dropDownItemId The current drop down id to ensure validation doesn't take place for item being updated
 */
export function dropDownItemTakenValidator(dropDown: IDropDownView, dropDownItemId: number): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } => {
        const val: any = control.value;

        let filteredItems: IDropDownItemView[] = dropDown.items.filter(item =>
            item.id !== dropDownItemId && item.text.toLowerCase() === val.toLowerCase());
        if (filteredItems.length > 0) {
            return { "dropDownItemTakenValidator": { val } };
        }
        return null;
    };
}